// API Configuration based on environment
export const API_ENDPOINTS = {
  development: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'https://aimock.mobile-bot.deriv.dev',
    directUrl: 'https://aimock.mobile-bot.deriv.dev',
  },
  production: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'https://aimock.mobile-bot.deriv.dev',
    directUrl: 'https://aimock.mobile-bot.deriv.dev',
  }
} as const;

// Determine current environment
const isDevelopment = import.meta.env.DEV;

// Get current API configuration
export const getCurrentApiConfig = () => {
  if (isDevelopment) {
    return API_ENDPOINTS.development;
  }
  return API_ENDPOINTS.production;
};

// API Configuration
export const API_CONFIG = {
  get BASE_URL() {
    return getCurrentApiConfig().baseUrl;
  },
  get DIRECT_URL() {
    return getCurrentApiConfig().directUrl;
  },
  VERSION: 'v1',
  TIMEOUT: 30000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
} as const;

// CORS configuration for production
export const CORS_CONFIG = {
  mode: 'cors' as RequestMode,
  credentials: 'omit' as RequestCredentials,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
};
